import React from 'react';
import Hero from './sections/Hero';
import Marquee from './sections/Marquee';
import Categories from './sections/Categories';
import FeaturedProviders from './sections/FeaturedProviders';
import HowItWorks from './sections/HowItWorks';
import WhyChoose from './sections/WhyChoose';
import FinalCta from './sections/FinalCta';

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-white dark:bg-gray-950">
      <Hero />
      <Marquee />
      <Categories />
      <FeaturedProviders />
      <HowItWorks />
      <WhyChoose />
      <FinalCta />
    </div>
  );
}
